import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

const HTMLElement = forwardRef((props, ref) => {
  const {
    id,
    className,
    style,
    htmlElement: Tag,
    htmlAttributes,
    children,
  } = props;

  const mergedClasses = [
    className,
    htmlAttributes.className,
  ].filter(Boolean).join(' ');

  const mergedStyle = {
    ...htmlAttributes.style,
    ...style,
  };

  return (
    <Tag
      {...htmlAttributes}
      id={id}
      className={mergedClasses || undefined}
      style={mergedStyle}
      ref={ref}
    >
      {children && children}
    </Tag>
  );
});

HTMLElement.defaultProps = {
  id: undefined,
  className: undefined,
  style: {},
  htmlElement: 'div',
  htmlAttributes: {},
  children: undefined,
};

HTMLElement.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.shape({}),
  htmlElement: PropTypes.string,
  htmlAttributes: PropTypes.shape({
    id: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.shape({}),
  }),
  children: PropTypes.node,
};

export default HTMLElement;
